import React, { Component } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SpeechTerapyResultsAPI from '../api/SpeechTerapyResultsAPI';
import Spinner from 'react-bootstrap/Spinner';
import { CKEditor } from '@ckeditor/ckeditor5-react';
//import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class StudySpeechTerapyResults extends Component {

    constructor() {
        super();
        this.state = {
            mode: '',
            formats: [],
            format: 0,
            nameFormat: '',
            results: '',
            load: false
        }
    }

    componentDidMount() {
        this.listFormatsStudy();
    }

    listFormatsStudy = async () => {
        this.setState({ load: true });
        let data = await SpeechTerapyResultsAPI.listActualFormats();
        this.setState({ formats: data }, () => { this.setState({ load: false }) });
    }

    createFormatsStudy = async () => {
        let dataSend = {
            nombre: this.state.nameFormat,
            formato: this.state.results
        }
        let data = await SpeechTerapyResultsAPI.createFormat(dataSend);
        this.setState({ formats: [...this.state.formats, data], load: true }, () => {
            setTimeout(() => {
                this.setState({ load: false }, () => {
                    this.cleanData();
                })
            }, 500);
        });
    }

    updateFormatsStudy = async () => {
        let dataSend = {
            id_formato: this.state.format,
            nombre: this.state.nameFormat,
            formato: this.state.results
        }
        let data = await SpeechTerapyResultsAPI.updateFormat(dataSend);
        let actualFormats = [...this.state.formats];
        actualFormats[actualFormats.findIndex(format => format.id_formato === data.id_formato)] = data;
        this.setState({ formats: actualFormats, load: true }, () => {
            setTimeout(() => {
                this.setState({ load: false }, () => {
                    this.cleanData();
                })
            }, 500);
        });
    }

    deleteFormatsStudy = async () => {
        let dataSend = {
            id_formato: this.state.format,
        }
        let data = await SpeechTerapyResultsAPI.deleteFormat(dataSend);
        let actualFormats = this.state.formats.filter(format => format.id_formato != this.state.format);
        this.setState({ formats: actualFormats, load: true }, () => {
            setTimeout(() => {
                this.setState({ load: false }, () => {
                    this.cleanData();
                })
            }, 500);
        });
    }

    cleanData = () => {
        this.setState({ format: 0, nameFormat: '', results: '' });
    }

    handlerChangeFormats = (value) => {
        this.setState({ format: value }, () => {
            let selectedFormat = this.state.formats.find(f => f.id_formato == this.state.format);
            if (selectedFormat != null && selectedFormat != undefined) {
                this.setState({ nameFormat: selectedFormat.nombre, results: selectedFormat.formato });
            }
            else {
                this.setState({ nameFormat: "", results: "" });
            }
        });
    }

    handlerChangeNameFormat = (value) => {
        this.setState({ nameFormat: value });
    }

    handlerChangeResults = (value) => {
        this.setState({ results: value });
    }

    render() {
        return (
            <>
                <div className="card__title">
                    <h5 className="bold-text">Resultados de Estudio (Fonoaudiologia)</h5>
                </div>
                <br />
                {this.state.load ? <div className="text-center">
                    <Spinner animation="border" variant="success" />
                </div> : null}
                <Row>
                    <Col md={6}>
                        <TextField
                            id="selectFormat"
                            label="Formato"
                            select
                            value={this.state.format}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                this.handlerChangeFormats(event.target.value);
                            }}
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                        >
                            <MenuItem key={0} value={0}>
                                {/*<FontAwesomeIcon icon={faPlusSquare} /> &nbsp;*/} {'Nuevo Formato'}
                            </MenuItem>
                            {this.state.formats.map((formatResult) => {
                                return <MenuItem key={formatResult.id_formato} value={formatResult.id_formato}>
                                    {formatResult.nombre}
                                </MenuItem>
                            })}
                        </TextField>
                    </Col>
                    <Col md={6}>
                        <TextField
                            required
                            className='medical-material-form__field'
                            id="formatName"
                            label="Nombre del Formato"
                            value={this.state.nameFormat}
                            onChange={(event) => {
                                this.handlerChangeNameFormat(event.target.value);
                            }}
                        />
                    </Col>
                </Row>
                <br /><br />

                <div>
                    <span>Resultados</span>
                    <div style={{ margin: 10 }}>
                        <CKEditor
                            style={{ width: '100%', height: '200px' }}
                            editor={ClassicEditor}
                            data={this.state.results != null ? this.state.results : null}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.handlerChangeResults(data)
                            }}
                        />
                    </div>
                </div>

                <br /><br />
                {
                    this.state.format != 0 && this.state.format != null && this.state.format != undefined ?

                        <>
                            <Button color="primary" onClick={this.updateFormatsStudy}>
                                Actualizar
                            </Button>
                            <Button color="danger" onClick={this.deleteFormatsStudy}>
                                Eliminar
                            </Button>
                        </>
                        : <Button color="primary" onClick={this.createFormatsStudy}>
                            Crear
                        </Button>
                }
            </>
        );
    }
}

export default reduxForm({
    form: `SpeechTerapy-temple-results-form`, // a unique identifier for this form
})(withTranslation('common')(StudySpeechTerapyResults));